module.exports = __webpack_public_path__ + "img/user.29479ba0.png";